import { getHelpCategoryIcon } from './helpIcons.js';
import { resolveTrainingCategorySlug } from './helpSlugRedirects.js';

const HELP_TRAINING_CATEGORIES_TR = [
  {
    slug: 'betting-strategies',
    title: 'Bahis stratejileri',
    desc: 'Uzun vadede kârı artırın ve tekli bahis kazanma yüzdesini yükseltin.',
    iconKey: 'strats',
    articles: [
      {
        slug: 'futbol',
        title: 'Futbol bahis stratejileri',
        content: [
          'Futbol bahislerinde uzun vadeli başarı, lig formu, sakatlık listesi ve iç saha performansını birlikte okumaktan geçer. VurgunBet maç merkezinde xG, şut ve korner verileri tekli bahis seçimini destekler.',
          'Değer bahsi ararken kendi olasılık tahmininizi VurgunBet oranıyla karşılaştırın. Favori takımlara körü körüne oynamak yerine handikap ve takım toplamı marketlerinde daha iyi oran arayın. Derbi ve küme düşme maçlarında düşük skorlu senaryoları ayrı değerlendirin.',
          'Bankroll\'unuzun %1–3\'ü kadar sabit birim kullanın. Haftalık lig takibi yapın ve aynı gün çok sayıda kombine yerine seçilmiş tekli bahisleri tercih edin.',
        ],
      },
      {
        slug: 'siber-futbol',
        title: 'Siber futbol stratejileri',
        content: [
          'Siber futbol (e-futbol), simülasyon motoruyla oynanan kısa süreli karşılaşmalardan oluşur. Maç süresi genelde 2×6 veya 2×4 dakikadır; tempo gerçek futboldan çok daha yüksektir.',
          'VurgunBet siber futbol programında aynı e-sporcu eşleşmeleri gün içinde tekrarlanır; önceki sonuçları körü körüne takip etmeyin. Canlı gol marketlerinde gecikme riski yüksektir; maç öncesi toplam gol tercih edilebilir.',
          'Düşük tutarlı tekli bahisler ve günlük durma limiti siber futbolda zorunludur. Simülasyon RNG ve form güncellemeleri kısa seriler üretebilir; uzun vadeli istatistik tutarak kalıpları abartmayın.',
        ],
      },
      {
        slug: 'futbol-total',
        title: 'Futbol toplam gol stratejisi',
        content: [
          'Toplam gol bahislerinde lig ortalaması, hava koşulu ve takım oyun tarzı belirleyicidir. Savunma odaklı takımların maçlarında 2,5 alt; açık oyun sergileyen eşleşmelerde üst değerlendirilir.',
          'VurgunBet\'te Asya toplamı çeyrek çizgilerle kısmi kazanç veya iade sunar. Canlı bahiste erken gol sonrası üst oranları yükselir; acele etmek yerine maç temposunu birkaç dakika izleyin.',
          'Her iki takımın son beş maçındaki gol ortalamasını not edin. Kupa maçlarında rotasyon ve düşük motivasyon düşük skorlu senaryoları güçlendirebilir.',
        ],
      },
      {
        slug: 'futbol-beraberlik',
        title: 'Futbol beraberlik stratejisi',
        content: [
          'Beraberlik bahisleri yüksek oran sunar ancak futbol maçlarının yaklaşık dörtte biri berabere biter. Dengeli güçteki takımlar ve düşük skorlu geçmiş eşleşmeler adaydır.',
          'Çifte şans (1X veya X2) beraberlik riskini azaltır; oran düşer ama kazanma olasılığı artar. VurgunBet İskandinav beraberliği marketlerinde normal süre berabere kalırsa iade alırsınız.',
          'Kapanış maçlarında taraflar beraberliğe razı olabilir; lig tablosu ve motivasyonu kontrol edin. Canlıda skor 0-0 iken beraberlik oranı düşer; değer kalmadıysa bahis atlayın.',
        ],
      },
      {
        slug: 'futbol-korner',
        title: 'Futbol korner stratejisi',
        content: [
          'Korner marketleri kanat oyunu güçlü ve pres yapan takımlarda değer üretir. Ortalama korner istatistiklerini VurgunBet maç merkezinden takip edin.',
          'Favori takım gerideyse korner sayısı artma eğilimindedir. Canlı bahiste ilk yarı korner toplamı, maç temposu oturmadan risklidir; maç öncesi çizgi daha öngörülebilir olabilir.',
          'Hava koşulu ve saha genişliği korner sayısını etkiler. Aşırı yüksek canlı üst oranlarına karşı kapanış dakikalarında oyun yavaşlayabileceğini unutmayın.',
        ],
      },
      {
        slug: 'tenis',
        title: 'Tenis bahis stratejileri',
        content: [
          'Teniste yüzey türü (toprak, çim, sert) performansı doğrudan etkiler. VurgunBet maç kartında yüzey geçmişi ve servis kırma yüzdelerini inceleyin.',
          'Set bahisleri ve handikap oyun marketleri maç sonucundan daha dengeli oran sunabilir. İlk seti kaybeden favoriler için canlı geri dönüş senaryolarını aşırı ağırlıklandırmayın.',
          'Sıkışan fikstür ve sakatlık sonrası kısa dinlenme süreleri sürpriz sonuç üretir. Tekli bahis ve düşük birimle Grand Slam erken turlarında underdog araştırması yapın.',
        ],
      },
      {
        slug: 'masa-tenisi',
        title: 'Masa tenisi stratejileri',
        content: [
          'Masa tenisi maçları kısa setler halinde hızlı sonuçlanır; momentum set içinde sık değişir. VurgunBet canlı masa tenisinde skor gecikmesine dikkat edin.',
          'Set skoru 2-2 olduğunda son set marketleri volatilitedir. Maç öncesi set handikapı, form istikrarı yüksek oyuncularda değerli olabilir.',
          'Aynı gün çoklu maç oynayan oyuncularda yorgunluk faktörünü değerlendirin. Yüksek oranlı sürpriz arayışında bankroll\'un küçük bir kısmını ayırın.',
        ],
      },
      {
        slug: 'hokey',
        title: 'Hokey bahis stratejileri',
        content: [
          'Buz hokeyinde uzatma ve penaltı dahil marketler ayrı listelenir; çoğu maç sonucu bahisi yalnızca normal süreyi kapsar. VurgunBet market açıklamasını her zaman okuyun.',
          'Güç oyunu ve kaleci formu skoru etkiler. Üç yönlü toplam ve takım toplamı kombinasyonları gol ortalaması yüksek liglerde uygundur.',
          'Play-off serilerinde deplasman avantajı ve yorgunluk belirgindir. Canlı bahiste ceza dakikaları oyun temposunu aniden değiştirir; erken bahis yerine durumu izleyin.',
        ],
      },
      {
        slug: 'futbol-canli',
        title: 'Canlı futbol stratejileri',
        content: [
          'Canlı futbol bahislerinde oranlar gol, kart ve VAR kararlarıyla saniyeler içinde değişir. VurgunBet canlı merkezinde xG ve topa sahip olma verisi kararınızı destekler.',
          'Favori gerideyken handikap ve toplam üst oranları yükselir; duygusal bahis yerine maç akışını değerlendirin. Kupon kabul gecikmesi (suspension) sık görülür; onaylanmayan bahisleri tekrarlamayın.',
          'İlk yarı 0-0 kapanan maçlarda ikinci yarı gol marketleri istatistiksel olarak açılır. Cash out kullanırken komisyon ve güncel oranı kıyaslayın; erken satış her zaman optimum değildir.',
        ],
      },
      {
        slug: 'voleybol',
        title: 'Voleybol bahis stratejileri',
        content: [
          'Voleybolda set handikapı ve toplam sayı marketleri maç sonucundan daha stabil olabilir. Ev sahibi avantajı ve rotasyon kadrosu set dağılımını etkiler.',
          'VurgunBet canlı voleybolda set sonuçları hızlı güncellenir. 0-2 geriden gelen takımlara uzun vadede aşırı güvenmeyin; set bazlı analiz yapın.',
          'Uluslararası maçlarda seyahat ve saat farkı performansı düşürebilir. Tie-break oynanan setlerde toplam sayı çizgisini ayrı değerlendirin.',
        ],
      },
      {
        slug: 'basketbol',
        title: 'Basketbol bahis stratejileri',
        content: [
          'Basketbolda tempo (possessions per game) ve üç sayı yüzdesi toplam sayı tahmininin temelidir. VurgunBet NBA ve EuroLeague maçlarında çeyrek bazlı marketler sunar.',
          'Yıldız oyuncu sakatlığı spread ve toplam çizgisini anında hareket ettirir. Canlıda son çeyrek faul serileri skoru şişirebilir; erken çeyrek toplamı daha öngörülebilir olabilir.',
          'Back-to-back maçlarda savunma konsantrasyonu düşer. Handikap yerine takım toplamı ile taraf bahsini ayırarak riski dağıtın.',
        ],
      },
      {
        slug: 'beyzbol',
        title: 'Beyzbol bahis stratejileri',
        content: [
          'Beyzbolda başlangıç atıcısı (pitcher) performansı maç sonucunun en kritik girdisidir. VurgunBet programında muhtemel atıcı değişikliklerini maç saatine kadar kontrol edin.',
          'Run line (handikap) ve toplam run marketleri farklı risk profili sunar. Hava ve stadyum faktörleri toplam sayıyı etkiler; rüzgarlı günlerde alt değerlendirilebilir.',
          'Uzun sezon istatistikleri kısa serilerden güvenilirdir. İlk beş vuruş (F5) marketleri yalnızca erken atıcı performansına odaklanır; canlı oyun tarzı değişiminden daha az etkilenir.',
        ],
      },
      {
        slug: 'outsider',
        title: 'Alt atlatan (outsider) stratejisi',
        content: [
          'Alt atlatan bahisleri yüksek oran vaat eder; kazanma sıklığı düşüktür. Uzun vadede kâr için yalnızca gerçekten değerli gördüğünüz sürprizleri oynayın.',
          'VurgunBet\'te underdog seçerken sakatlık, motivasyon ve oyun stilini inceleyin. Küçük liglerde bilgi asimetrisi değer yaratabilir ancak likidite düşük olabilir.',
          'Alt atlatanı kombineye çoklu eklemek riski katlar. Tekli ve düşük birimle oynayın; kayıp serisinde tutarı artırmayın.',
        ],
      },
      {
        slug: 'tenis-canli',
        title: 'Canlı tenis stratejileri',
        content: [
          'Canlı teniste servis kıran taraf momentum kazanır. VurgunBet canlı oranları her puan sonrası güncellenir; gecikmeli bahis kabulünden kaçının.',
          'İlk set kaybından sonra favori oranları yükselir; fiziksel düşüş veya sakatlık işareti yoksa değer aranabilir. Tie-break oynanan setlerde toplam oyun marketleri volatildir.',
          'Yağmur gecikmesi veya tıbbi mola oranları dondurur. Maç tekrar başladığında piyasa yeniden fiyatlanır; acele karar vermeyin.',
        ],
      },
    ],
  },
  {
    slug: 'beginner-tips',
    title: 'Yeni başlayanlar için ipuçları',
    desc: 'Yeni başlayanlar için faydalı bahis tavsiyeleri.',
    iconKey: 'adv',
    articles: [
      {
        slug: 'bankroll-yonetimi',
        title: 'Bankroll yönetimi',
        content: [
          'Bankroll, bahis için ayırdığınız ve kaybetmeyi göze alabileceğiniz ayrı bütçedir. VurgunBet\'e yatırdığınız tutar günlük harcamalarınızdan bağımsız olmalıdır.',
          'Her bahiste bankroll\'un %1–5\'i arasında sabit birim kullanın. Kayıp serisinde tutarı ikiye katlamak (martingale) hesabı hızla tüketir. Haftalık ve aylık kayıp limiti belirleyin.',
          'Kazancın bir kısmını düzenli çekin; tüm kârı tekrar bahse yatırmak riski artırır. VurgunBet hesap ayarlarından yatırım limiti koyarak disiplini destekleyebilirsiniz.',
        ],
      },
      {
        slug: 'oran-okuma',
        title: 'Oran okuma ve değer bulma',
        content: [
          'Oran, bahis şirketinin olasılık tahmininin ters çevrimidir. 2,00 oran yaklaşık %50 olasılık anlamına gelir; VurgunBet marjı nedeniyle gerçek olasılık biraz daha düşüktür.',
          'Kendi tahmininiz şirket olasılığından yüksekse değer bahsi vardır. Farklı marketleri (handikap, toplam, çifte şans) kıyaslayarak en iyi oranı seçin.',
          'Oran düşüşü (steam) piyasanın yönünü gösterir; geç kalmadan önce analizinizi tamamlayın. Aşırı yüksek oranlı küçük liglerde limitler düşük olabilir.',
        ],
      },
      {
        slug: 'canli-bahis',
        title: 'Canlı bahise başlarken',
        content: [
          'Canlı bahis hızlı karar gerektirir; maçı izlemeden oynamak dezavantajlıdır. VurgunBet canlı istatistik panelini kupon oluşturmadan önce kontrol edin.',
          'Kupon askıya alındığında (suspension) onaylanmayan bahis geçersizdir; tekrar yüksek tutar denemeyin. Gol ve VAR incelemelerinde oranlar kapanır.',
          'Canlıda duygusal tepki yerine önceden belirlediğiniz senaryolara bağlı kalın. Günlük canlı bahis limiti koymak yeni başlayanlar için önerilir.',
        ],
      },
      {
        slug: 'kombine-bahis',
        title: 'Kombine bahis ipuçları',
        content: [
          'Kombine bahis (ekspres), seçimlerin çarpımıyla yüksek toplam oran üretir; tüm seçimler tutmalıdır. VurgunBet kombine kuponunda seçim sayısını makul tutun.',
          'İlişkili aynı maç seçimleri (yatay kombine) korelasyon riski taşır. Farklı lig ve saatlerden bağımsız maçlar riski dağıtır.',
          'Büyük kombineler uzun vadede kârlı değildir. İki veya üç seçimli düşük oranlı kombineler veya tekli bahisler yeni başlayanlar için daha güvenlidir.',
        ],
      },
      {
        slug: 'sorumlu-oyun',
        title: 'Sorumlu oyun ilkeleri',
        content: [
          'Bahis eğlence amaçlı olmalı; kayıpları telafi etmek için borç almak veya bütçeyi aşmak uygun değildir. VurgunBet 18 yaş altına hizmet vermez.',
          'Hesap ayarlarından günlük, haftalık yatırım limiti, kayıp limiti ve oturum süresi hatırlatıcısı etkinleştirebilirsiniz. Gerekirse geçici veya kalıcı öz-dışlama talep edin.',
          'Kontrol kaybı hissediyorsanız destek hattı ve sorumlu oyun kaynaklarından yardım alın. Bahis geçmişinizi düzenli inceleyerek harcama alışkanlığınızı objektif değerlendirin.',
        ],
      },
    ],
  },
];

const HELP_TRAINING_CATEGORIES_EN = [
  {
    slug: 'betting-strategies',
    title: 'Betting strategies',
    desc: 'Improve long-term profit and single-bet win rate.',
    iconKey: 'strats',
    articles: [
      {
        slug: 'futbol',
        title: 'Football betting strategies',
        content: [
          'Long-term football success comes from reading form, injuries and home advantage together. VurgunBet match centre xG and shot data support single-bet selection.',
          'Compare your probability estimate to VurgunBet odds for value. Prefer handicap and team totals over blind favourites.',
          'Use a flat 1–3% unit stake and favour selected singles over large accumulators.',
        ],
      },
      {
        slug: 'siber-futbol',
        title: 'Cyber football strategies',
        content: [
          'Cyber football uses short simulated matches with very high tempo.',
          'Repeated pairings on VurgunBet repeat daily; do not chase streaks blindly. Live goal markets carry delay risk.',
          'Use small singles and a daily stop-loss; simulation form can produce short random runs.',
        ],
      },
      {
        slug: 'futbol-total',
        title: 'Football totals strategy',
        content: [
          'League scoring averages, weather and playing style drive totals betting.',
          'Asian totals on VurgunBet offer partial wins and pushes. Watch tempo before live overs after early goals.',
          'Cup ties and rotation can favour unders.',
        ],
      },
      {
        slug: 'futbol-beraberlik',
        title: 'Football draw strategy',
        content: [
          'Draw bets pay high odds but land less often than wins. Evenly matched low-scoring teams are candidates.',
          'Double chance reduces draw risk at lower odds. Scandinavian draw rules refund on level scores.',
          'Final-round motivation can favour draws; check the table.',
        ],
      },
      {
        slug: 'futbol-korner',
        title: 'Football corners strategy',
        content: [
          'Corner markets suit wide attacks and pressing teams. Track averages in the VurgunBet match centre.',
          'Trailing favourites often generate more corners. First-half live corners are volatile.',
          'Weather and pitch size matter; late-game slowdown can hurt live overs.',
        ],
      },
      {
        slug: 'tenis',
        title: 'Tennis betting strategies',
        content: [
          'Surface type strongly affects tennis performance. Review serve-break stats on VurgunBet.',
          'Set betting and game handicaps can offer smoother odds than match winner.',
          'Fatigue and tight schedules increase upsets; research underdogs with small stakes.',
        ],
      },
      {
        slug: 'masa-tenisi',
        title: 'Table tennis strategies',
        content: [
          'Table tennis sets finish quickly; momentum shifts within sets.',
          'Deciding sets are volatile; pre-match set handicaps suit stable form.',
          'Factor fatigue when players have many matches in one day.',
        ],
      },
      {
        slug: 'hokey',
        title: 'Ice hockey strategies',
        content: [
          'Check whether markets include overtime and shootouts on VurgunBet.',
          'Power plays and goalie form drive scoring. Play-off travel and fatigue matter.',
          'Live penalties change tempo suddenly; wait before betting.',
        ],
      },
      {
        slug: 'futbol-canli',
        title: 'Live football strategies',
        content: [
          'Live odds move on goals, cards and VAR. Use xG and possession in the live centre.',
          'Avoid emotional bets when favourites trail. Do not repeat rejected slips during suspensions.',
          'Cash out is not always optimal; compare the offered value to remaining risk.',
        ],
      },
      {
        slug: 'voleybol',
        title: 'Volleyball strategies',
        content: [
          'Set handicaps and totals can be steadier than match winner in volleyball.',
          'Live set scores update fast on VurgunBet. Analyse set-by-set rather than 0-2 comebacks alone.',
          'Tie-break sets need separate total evaluation.',
        ],
      },
      {
        slug: 'basketbol',
        title: 'Basketball strategies',
        content: [
          'Pace and three-point rate anchor basketball totals. Quarter markets are available on VurgunBet.',
          'Star injuries move spreads instantly. Back-to-back games hurt defence.',
          'Split side and team total risk instead of loading one market.',
        ],
      },
      {
        slug: 'beyzbol',
        title: 'Baseball strategies',
        content: [
          'Starting pitcher form is critical. Confirm probable starters before first pitch on VurgunBet.',
          'Wind and park factors affect totals. First five innings (F5) isolate early pitching.',
          'Trust long-season samples over short streaks.',
        ],
      },
      {
        slug: 'outsider',
        title: 'Underdog strategy',
        content: [
          'Underdogs pay high odds with low hit rates. Only bet clear value spots.',
          'Check injuries and motivation on VurgunBet. Small leagues can hide value with low limits.',
          'Do not stack many underdogs in one accumulator.',
        ],
      },
      {
        slug: 'tenis-canli',
        title: 'Live tennis strategies',
        content: [
          'Break of serve shifts live momentum. Avoid betting during acceptance delays.',
          'Favourite prices rise after losing the first set if no injury signs appear.',
          'Rain delays freeze markets; reassess after resumption.',
        ],
      },
    ],
  },
  {
    slug: 'beginner-tips',
    title: 'Tips for beginners',
    desc: 'Practical betting advice for new players.',
    iconKey: 'adv',
    articles: [
      {
        slug: 'bankroll-yonetimi',
        title: 'Bankroll management',
        content: [
          'Bankroll is a separate budget you can afford to lose. Keep it apart from daily expenses.',
          'Use a flat 1–5% unit per bet. Avoid doubling stakes after losses. Set weekly loss caps.',
          'Withdraw part of profits regularly. VurgunBet deposit limits support discipline.',
        ],
      },
      {
        slug: 'oran-okuma',
        title: 'Reading odds and finding value',
        content: [
          'Odds reflect implied probability plus margin. 2.00 implies roughly 50% before margin.',
          'If your estimate beats the book, you have value. Compare markets for the best price.',
          'Steam moves show market direction; act before odds collapse.',
        ],
      },
      {
        slug: 'canli-bahis',
        title: 'Starting with live betting',
        content: [
          'Watch the event when possible. Check live stats on VurgunBet before betting.',
          'Suspended slips are void; do not chase with larger stakes.',
          'Predefine scenarios and set a daily live betting cap.',
        ],
      },
      {
        slug: 'kombine-bahis',
        title: 'Accumulator tips',
        content: [
          'All legs must win in an accumulator. Keep selection count modest on VurgunBet.',
          'Same-game multis are correlated. Spread risk across independent matches.',
          'Large accas are poor long-term value; 2–3 legs or singles suit beginners.',
        ],
      },
      {
        slug: 'sorumlu-oyun',
        title: 'Responsible gaming',
        content: [
          'Bet for entertainment only; never chase losses with borrowed money. VurgunBet is 18+.',
          'Use deposit, loss and session limits in account settings. Self-exclusion is available.',
          'Review bet history regularly and seek help if control slips.',
        ],
      },
    ],
  },
];

function trainingLocaleKey(locale) {
  return locale === 'en' ? 'en' : 'tr';
}

const TRAINING_CATEGORIES_BY_LOCALE = {
  tr: HELP_TRAINING_CATEGORIES_TR,
  en: HELP_TRAINING_CATEGORIES_EN,
};

export function getTrainingCategories(locale = 'tr') {
  return TRAINING_CATEGORIES_BY_LOCALE[trainingLocaleKey(locale)].map(
    ({ slug, title, desc, iconKey }) => ({
      slug,
      title,
      desc,
      icon: getHelpCategoryIcon(iconKey),
    }),
  );
}

export function getTrainingArticles(catSlug, locale = 'tr') {
  const category = TRAINING_CATEGORIES_BY_LOCALE[trainingLocaleKey(locale)].find(
    (cat) => cat.slug === resolveTrainingCategorySlug(catSlug),
  );
  if (!category) return [];
  return category.articles.map(({ slug, title, content }) => ({ slug, title, content }));
}

export function getTrainingArticle(catSlug, articleSlug, locale = 'tr') {
  const category = TRAINING_CATEGORIES_BY_LOCALE[trainingLocaleKey(locale)].find(
    (cat) => cat.slug === resolveTrainingCategorySlug(catSlug),
  );
  if (!category) return null;
  const article = category.articles.find((item) => item.slug === articleSlug);
  if (!article) return null;
  return {
    category: { slug: category.slug, title: category.title, desc: category.desc },
    slug: article.slug,
    title: article.title,
    content: article.content,
  };
}

export { HELP_TRAINING_CATEGORIES_TR, HELP_TRAINING_CATEGORIES_EN };
